export default "__VITE_ASSET__DrXW5HH1__"